import { useEffect, useState } from "react";
import Header from "../../Common/Header";
import GuardianList from "../../Components/GuardinList";
import Loader from "../../loader";

const GuardianReviewList = () => {
  return (
    <>
      <GuardianList />
    </>
  );
};

export default GuardianReviewList;
